import { render, staticRenderFns } from "./view-order.vue?vue&type=template&id=21129560&"
import script from "./view-order.vue?vue&type=script&lang=ts&"
export * from "./view-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports